import * as React from 'react';

export interface InvestorDeckTabsComponentProps {
  investorDeckSection: string;
  handleClick: (value: string) => void;
}

class InvestorDeckTabsComponent extends React.PureComponent<InvestorDeckTabsComponentProps> {
  public render(): React.ReactNode {
    return (
      <div className="row investor-deck-tabs">
        <div className="col-xs-6 padding-r-0">
          <div
            className={this.props.investorDeckSection === 'companyInformation' ?
              'tab edit-project-tab tab-active' : 'tab edit-project-tab'}
          >
            <div className="icon">
              <img
                alt="Building"
                className="icon"
                src="/img/building-big-inactive.png"
              />
            </div>
            <div className="title">
              <h4><strong>1. Información <br/> de la empresa</strong></h4>
            </div>
          </div>
        </div>
        <div className="col-xs-6 padding-l-r-0">
          <div
            className={this.props.investorDeckSection === 'investorDeck' ?
              'tab edit-project-tab tab-active' : 'tab edit-project-tab tab-2'}
          >
            <div className="icon">
              <img
                style={{height: '31px', width: '30px'}}
                alt="Building"
                className="icon"
                src="/img/graphic-big.png"
              />
            </div>
            <div className="title">
              <h4><strong>2. Envía tu <br/> "Investor Deck"</strong></h4>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default InvestorDeckTabsComponent;


// WEBPACK FOOTER //
// ./src/modules/investor-deck/partials/InvestorDeckTabs.component.tsx